import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-0.5,0h1.5v0.5h-1.5z' },
    {
      paint: [
        ['goat', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-1,-4.5h0.5v0.5h-0.5zM-2.5,-4h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1zM-3,-3h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h1.5v0.5h-1.5zM-1.5,-1h1v1.5h-1zM0.5,-1h1v0.5h-1zM1,-0.5h0.5v1h-0.5z',
    },
    {
      paint: 'goat',
      d: 'M-3,-4.5h1.5v0.5h-1.5zM-3,-4h0.5v0.5h-0.5zM-2,-4h0.5v0.5h-0.5zM2,-4h0.5v0.5h-0.5zM-3,-3.5h2v0.5h-2zM1.5,-3.5h1v0.5h-1zM-2.5,-3h1.5v0.5h-1.5zM1,-3h1v0.5h-1zM-2.5,-2.5h5v0.5h-5zM-2,-2h3.5v0.5h-3.5zM2,-2h0.5v0.5h-0.5zM-2,-1.5h2v0.5h-2zM1.5,-1.5h0.5v1.5h-0.5zM-2,-1h0.5v1h-0.5z',
    },
    {
      paint: [
        ['goat', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1,-3.5h2.5v0.5h-2.5zM-1,-3h2v0.5h-2z',
    },
    {
      paint: 'goatHorn',
      d: 'M-3,-5.5h1.5v0.5h-1.5zM-3,-5h2v0.5h-2zM-1.5,-4.5h0.5v0.5h-0.5zM-2.5,0h1v0.5h-1zM1.5,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 86,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-0.5,0h1.5v0.5h-1.5z' },
    {
      paint: [
        ['goat', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-2,-2.5h0.5v1h-0.5zM-3,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h1.5v0.5h-1.5zM-3,-1h0.5v1h-0.5zM-1.5,-1h1v1.5h-1zM0.5,-1h1v0.5h-1zM1,-0.5h0.5v1h-0.5z',
    },
    {
      paint: 'goat',
      d: 'M2,-4h0.5v0.5h-0.5zM1.5,-3.5h1v0.5h-1zM1,-3h1v0.5h-1zM-1.5,-2.5h4v0.5h-4zM-2.5,-2h0.5v0.5h-0.5zM-1.5,-2h3v0.5h-3zM2,-2h0.5v0.5h-0.5zM-3,-1.5h3v0.5h-3zM1.5,-1.5h0.5v1.5h-0.5zM-2.5,-1h1v0.5h-1zM-2,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['goat', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-1.5,-3.5h3v0.5h-3zM-1.5,-3h2.5v0.5h-2.5z',
    },
    {
      paint: 'goatHorn',
      d: 'M-3.5,-3.5h0.5v0.5h-0.5zM-2,-3.5h0.5v0.5h-0.5zM-3.5,-3h2v0.5h-2zM-3,-2.5h1v0.5h-1zM-2.5,0h1v0.5h-1zM1.5,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 77,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-0.5,0h1.5v0.5h-1.5z' },
    {
      paint: [
        ['goat', 0.35],
        ['horse', 0.43],
        ['shadow', 0.22],
      ],
      d: 'M-1,-4.5h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1zM-3,-3h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM0,-1.5h1.5v0.5h-1.5zM-1.5,-1h1v1.5h-1zM0.5,-1h1v0.5h-1zM1,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['goat', 0.45],
        ['horse', 0.55],
      ],
      d: 'M-3,-4.5h2v0.5h-2zM-3,-4h1.5v0.5h-1.5zM2,-4h0.5v0.5h-0.5zM-3,-3.5h2v0.5h-2zM1.5,-3.5h1v0.5h-1zM-2.5,-3h1.5v0.5h-1.5zM1,-3h1v0.5h-1zM-2.5,-2.5h5v0.5h-5zM-2,-2h3.5v0.5h-3.5zM2,-2h0.5v0.5h-0.5zM-2,-1.5h2v0.5h-2zM1.5,-1.5h0.5v1.5h-0.5zM-2,-1h0.5v0.5h-0.5zM-3,-0.5h1.5v0.5h-1.5zM-2.5,0h0.5v0.5h-0.5zM1,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['goat', 0.32],
        ['horse', 0.38],
        ['snowCap', 0.3],
      ],
      d: 'M-1,-3.5h2.5v0.5h-2.5zM-1,-3h2v0.5h-2z',
    },
    {
      paint: 'goatHorn',
      d: 'M-2,-6h0.5v0.5h-0.5zM-2.5,-5.5h2v0.5h-2zM-3,-5h2v0.5h-2zM-3,0h0.5v0.5h-0.5zM1.5,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 90,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
